import React from 'react';

const EditText = ({
    placeholder = '',
    value = '',
    onChange,
    type = 'text',
    disabled = false,
    className = ''
}) => {
    return (
        <input
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`tw-w-full tw-px-4 tw-py-2 tw-bg-edittext-1 tw-text-global-8 tw-font-inter tw-text-sm tw-border tw-border-footer-text-2 tw-rounded-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-button-2 focus:tw-border-transparent ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''} ${className}`}
        />
    );
};

export default EditText;
